import * as React from 'react';
import { SVGProps } from 'react';

const SvgUpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8 12.667V3.333M3.333 8 8 3.333 12.667 8"
      stroke="#FF1B33"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgUpIcon;
